export default "__VITE_ASSET__bHyV3hZd__"